export default __webpack_public_path__ + "static/media/1573 - l3id.ac86e13c.jpeg";